<template>
    <div class="wallet-connect">
        <!-- <div v-if="isLogin">
            <span>{{ address }}</span>
        </div>
        <div v-else>
            <button @click="connect">Connect</button>
        </div> -->
        <div class="wallet" @click="connect" v-if="!Token">
            {{ $t('ConnectWallet') }}
            <!-- <img src="@/assets/images/EntryArrow.png" alt="" class="EntryArrow"/> -->
        </div>
        <div class="wallets" v-else>
            {{address.substr(0,4)}}***{{address.substring(address.length - 4)}}
            <!-- <img src="@/assets/images/EntryArrow.png" alt="" class="EntryArrow"/> -->
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { connectWallet } from '@/web3/index'
import { getToken } from '@/utils/auth'

export default {
    name: 'CBWalletConnect',
    data() {
        return {
            offTimer:null,
            Token:""
        }
    },
    computed: {
        ...mapState(['address']),
        ...mapGetters(['isLogin'])
    },
    watch: {
    },
    methods: {
        async connect() {
            const address = await connectWallet();
            this.$store.commit('setAddress', address.toLowerCase());
            this.$store.dispatch('login');
        }
    },
    mounted() {
        this.offTimer=setInterval(async ()=>{
            this.Token=getToken()
            // console.log('执行11',this.Token);
        },1000)
    },
    //离开页面时执行函数
    beforeDestroy() {         
      clearInterval(this.offTimer);  
      this.offTimer=null
    },
}
</script>
<style lang="less" scoped>
.wallet {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 25px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
      line-height: 63px;
      margin-right: 42px;
      text-align: center;
      width: 246px;
      height: 70px;
      background: #2C2C2E;
      border-radius: 8px;
    //   border: 2px solid #937B46;
      
      .EntryArrow {
        display: flex;
        width: 13px;
        margin-left: 15px;
        height: 20px;
      }
    }
    
    .wallets {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
      line-height: 63px;
      margin-right: 31px;
      text-align: center;
      width: 247px;
      height: 61px;
      border-radius: 29px;
      background: #2C2C2E;
    //   border: 2px solid #937B46;
      font-size: 25px;
      .EntryArrow {
        display: flex;
        width: 13px;
        margin-left: 15px;
        height: 20px;
      }
    }
</style>